import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getDefaultEmailTemplates,
  getEmailTemplates,
  saveEmailTemplate,
  saveNewEmailTemplateType,
} from "./DataServices/AutomaticResponsesDataServices";
import { PencilIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import {} from "@mui/icons-material";

import { IDefaultTemplates, IEmailAttachFile } from "./Models";
import TextEditor from "./TextEditor";
import {
  addEmailAttachFiles,
  getEmailAttachFiles,
} from "./DataServices/ApartmentsListingsDataServices";
import MessageBox from "./MessageBox";
const EmailTemplates = () => {
  const { apartmentId } = useParams();
  const [emailId, setEmailId] = useState<string>();
  const [templates, setTemplates] = useState<IDefaultTemplates[]>([]);
  const [defaultTemplates, setDefaultTemplates] = useState<
    Record<string, string>
  >({});
  const [emailTemplates, setEmailTemplates] = useState<Record<string, string>>(
    {},
  );
  const [emailIds, setEmailIds] = useState<Record<string, string>>({});
  const [defaultEmailIds, setDefaultEmailIds] = useState<
    Record<string, string>
  >({});
  const [docs, setDocs] = useState<IEmailAttachFile[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<string>();
  const [newTemplate, setNewTemplate] = useState<string>();
  const [selectedEmailBody, setSelectedEmailBody] = useState<string>();
  const [isDefaultTemplate, setIsDefaultTemplate] = useState(false);
  const [apartmentName, setApartmentName] = useState<string>();
  const [openMessageBox, setOpenMessageBox] = useState<boolean>(false);
  const tags = [
    "[First Name]",
    "[Last Name]",
    "[AppFolio Link]",
    "[YouTube Link]",
    "[Apartment Title]",
    "[Building Title]",
    "[Access Code]",
    "[Schedule Your Tour]",
    "[Reschedule Appointment]",
    "[Confirm Reschedule]",
    "[Cancel Appointment Link]",
    "[Add Tenants]",
    "[Description]",
    "[NumOfBedrooms]",
    "[Floor]",
    "[CurrentRent]",
    "[Start Time]",
    "[End Time]",
    "[MoveDate]",
    "[Link]",
    "[Property]",
    "[Receiver Name]",
    "[Receiver Email]",
    "[Bank Name]",
    "[Account Holder]",
    "[IFSC/Routing Code]",
    "[Submitted At]",
    "[PropertyTitle]",
    "[PropertyDescription]",
    "[ReceiverName]",
    "[ReceiverEmail]",
    "[TotalTenants]",
    "[ReceiverCount]",
    "[TenantList]",
    "[SelectedReceiverCount]",
    "[TenantMissing]",
    "[PendingTenants]",
    "[PendingGuarantors]",
    "[Move Out Date]",
    "[Name]",
  ];

  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDefaultEmailTemplates()
      .then((data) => {
        const mapped = data.reduce((acc: any, item: any) => {
          acc[item.emailType] = item.emailBody;
          return acc;
        }, {});

        const mapped2 = data.reduce((acc: any, item: any) => {
          acc[item.emailType] = item.id;
          return acc;
        }, {});

        setDefaultTemplates((prev) => ({
          ...prev,
          ...mapped,
        }));
        setDefaultEmailIds((prev) => ({
          ...prev,
          ...mapped2,
        }));
        setTemplates(data);
      })
      .catch((err) => {
        console.error("Error in getting default templates", err);
      });
  }, [saved]);

  useEffect(() => {
    if (apartmentId) {
      getEmailTemplates(apartmentId)
        .then((data) => {
          const mapped = data.reduce((acc: any, item: any) => {
            acc[item.emailType] = item.emailBody;
            return acc;
          }, {});

          const mapped2 = data.reduce((acc: any, item: any) => {
            acc[item.emailType] = item.id;
            return acc;
          }, {});

          setEmailTemplates((prev) => ({
            ...prev,
            ...mapped,
          }));
          setEmailIds((prev) => ({
            ...prev,
            ...mapped2,
          }));
          if (data.length > 0 && !emailId) {
            setSelectedTemplate(data[0].emailType);
            setSelectedEmailBody(data[0].emailBody);
            setEmailId(data[0].id);
          }
        })
        .catch((err) => {
          console.error("Error in getting email templates", err);
        });
    }
  }, [apartmentId, saved]);

  const handleSelectEmail = (emailType: string, id: string) => {
    setSelectedTemplate(emailType);
    if (emailType && id) {
      if (isDefaultTemplate) {
        if (defaultTemplates[emailType]) {
          setSelectedEmailBody(defaultTemplates[emailType]);
          setEmailId(defaultEmailIds[emailType]);
        } else setSelectedEmailBody("");
      } else {
        if (emailTemplates[emailType]) {
          setSelectedEmailBody(emailTemplates[emailType]);
          setEmailId(emailIds[emailType]);
        } else if (defaultTemplates[emailType]) {
          setSelectedEmailBody(defaultTemplates[emailType]);
          setEmailId(defaultEmailIds[emailType]);
        } else setSelectedEmailBody("");
      }
    }
  };

  useEffect(() => {
    selectedTemplate && emailId && handleSelectEmail(selectedTemplate, emailId);
  }, [isDefaultTemplate]);

  const saveNewTemplateType = async () => {
    try {
      if (!newTemplate) {
        throw Error("Input is empty");
      }
      await saveNewEmailTemplateType({
        id: "00000000-0000-0000-0000-000000000000",
        emailBody: "",
        emailType: newTemplate,
      });
      setNewTemplate("");
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (error) {
      console.log("Failed to save new emaiil template type");
    }
  };

  const saveTemplates = async () => {
    setLoading(true);
    setOpenMessageBox(false);
    try {
      if (!(apartmentId && selectedEmailBody && selectedTemplate)) {
        throw Error("save Email Template failed");
      }
      if (isDefaultTemplate) {
        await saveNewEmailTemplateType({
          id: "00000000-0000-0000-0000-000000000000",
          emailType: selectedTemplate,
          emailBody: selectedEmailBody,
        });
      } else {
        await saveEmailTemplate(
          apartmentId,
          selectedEmailBody,
          selectedTemplate,
        );
      }

      if (emailId && emailId.length > 0) {
        addEmailAttachFiles(docs);
      }
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <aside className="fixed top-0 left-0 z-10 w-64 shadow h-screen pt-16 transition-transform -translate-x-full bg-gray-100 border-r border-gray-200 sm:translate-x-0">
        <div className="h-full px-3 pb-4 overflow-y-auto bg-gray-100">
          <ul className="space-y-2">
            <li>
              <span className="flex items-center mb-2 p-2 text-gray-700 rounded-md bg-gray-200">
                <span className="text-sm flex w-full items-center justify-center gap-2">
                  <input
                    type="text"
                    placeholder="Enter email type ..."
                    value={newTemplate}
                    onChange={(e) => setNewTemplate(e.target.value)}
                    className="w-full max-w-[16rem] text-gray-600 text-xs rounded outline-none"
                  />
                  <PlusCircleIcon
                    title="Add New Email Type"
                    className="w-8 cursor-pointer"
                    onClick={() => saveNewTemplateType()}
                  />
                </span>
              </span>
              {templates &&
                templates.map((t) => {
                  return (
                    <span
                      key={t.id}
                      title={t.emailType + " Email"}
                      onClick={() => {
                        handleSelectEmail(t.emailType, t.id);
                      }}
                      className={
                        "flex items-center font-medium cursor-pointer mb-1 p-2 text-gray-700 rounded hover:bg-white " +
                        (t.emailType === selectedTemplate && "bg-white")
                      }
                    >
                      <span className="text-sm flex items-center justify-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 font-bold"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                          />
                        </svg>
                        <span className="whitespace-nowrap w-48 truncate">
                          {t.emailType} Email
                        </span>
                      </span>
                    </span>
                  );
                })}
            </li>
          </ul>
        </div>
      </aside>

      <div className="h-screen sm:ml-64 p-3">
        <div className="p-4 pt-16">
          <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200">
            <span className="flex flex-col items-start justify-center">
              <h1 className="text-xl font-medium text-gray-800">
                {isDefaultTemplate && "Default "}Email Templates
              </h1>
              <h4 className="text-sm text-red-400 mt-1">
                {isDefaultTemplate
                  ? "This template will apply to all listings that do not have their own template."
                  : "This template will override the default template for this particular listing."}
              </h4>
            </span>
            <span
              className="flex text-sm text-blue-600 font-medium cursor-pointer px-2 items-center justify-center gap-2"
              onClick={() => setIsDefaultTemplate(!isDefaultTemplate)}
            >
              <PencilIcon className="w-4" />
              Edit {!isDefaultTemplate && "default"}Templates
            </span>
          </div>
          {/* Template Editor */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-3">
              <h2 className={`font-medium text-gray-600`}>
                {selectedTemplate} Email Template
              </h2>
            </div>

            <div className="p-2 m-2 shadow border rounded-md">
              <h1 className="text-sm font-medium text-blue-600 mb-2">
                Use this tags only except in "Tranfer Apartment" Email
              </h1>
              <div className="flex text-sm text-gray-600 items-start flex-wrap gap-2">
                {tags.map((t) => {
                  return <span className="text-sm">{t}</span>;
                })}
              </div>
            </div>
          </div>
          <div className="border rounded">
            <div className="relative">
              <div className="flex flex-col w-full">
                {emailId && (
                  <TextEditor
                    content={selectedEmailBody ?? ""}
                    setContent={setSelectedEmailBody}
                    templateType={selectedTemplate}
                    height="60vh"
                    docs={docs}
                    setDocs={setDocs}
                    emailId={emailId}
                  />
                )}
              </div>

              {/* <textarea
                disabled={!selectedTemplate}
                value={selectedEmailBody}
                onChange={(e) => setSelectedEmailBody(e.target.value)}
                className={`w-full border rounded-lg shadow-sm text-sm p-4 h-[60vh] focus:outline-none`}
                placeholder="Write your email template here..."
              /> */}
            </div>
            {/* Action Buttons */}
            <div className="flex justify-end space-x-4 border-t p-3">
              <button
                className="px-4 py-2 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors"
                onClick={() => {
                  selectedTemplate &&
                    setSelectedEmailBody(defaultTemplates[selectedTemplate]);
                }}
              >
                Reset Current Template
              </button>

              <button
                className={`px-6 py-2 text-sm font-medium text-white rounded-md transition-colors ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : saved
                      ? "bg-green-500"
                      : "bg-blue-600 hover:bg-blue-700"
                }`}
                onClick={() => setOpenMessageBox(true)}
                disabled={loading}
              >
                {loading ? "Saving..." : saved ? "Saved!" : "Save Templates"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <MessageBox
        title={`Save ${isDefaultTemplate ? "Default " : ""}Email Template`}
        message={
          isDefaultTemplate
            ? "You are about to save this as the default email template. This template will apply to all listings that do not have their own template."
            : "You are about to save a listing-specific email template. This will override the default template for this particular listing."
        }
        isOpen={openMessageBox}
        setIsOpen={setOpenMessageBox}
        okButtonText="Ok"
        cancelButtonText="Cancel"
        okButtonFunction={saveTemplates}
        cancelButtonFunction={() => setOpenMessageBox(false)}
        okButtonStyle={{
          backgroundColor: "rgb(79, 70, 229)",
        }}
        iconColor={{ color: "rgb(79, 70, 229)" }}
      />
    </>
  );
};

export default EmailTemplates;
